$('#reviewsList').slick({
    variableWidth: false,
    slidesToShow: 1,
    dots: false,
    arrows: false,
    speed: 300,
    centerMode: false,
    initialSlide: 0,
    infinite: false,
    adaptiveHeight: true
});